import { formatMoneyDisplay } from "@client/lib/format";
import { useI18n } from "@common/hooks/i18n";
import { isNullOrUndefined } from "@common/lib/misc";
import { isNull, isUndefined } from "lodash";
import React from "react";
import { ProductList } from "../../types";

export type Price = ProductList.ProductPrice;

interface ProductPriceProps {
  oldPriceColor?: string;
  price: Price;
  regularPriceStyle?: React.CSSProperties;
  salePriceStyle?: React.CSSProperties;
  taxPercentage: number;
}
const ProductPrice = ({ price, ...props }: ProductPriceProps) => {
  const i18n = useI18n();

  const getTaxedPrice = React.useCallback(
    (price: number) => price + price * props.taxPercentage,
    [props.taxPercentage]
  );

  return (
    <div className="product-price">
      {!isNull(price.salesPrice) && !isUndefined(price.salesPrice) && price.salesPrice !== price.price ? (
        <>
          <span style={props.regularPriceStyle}>
            {isNullOrUndefined(price.fromPrice) ? null : i18n.from.toLowerCase() + " "}
          </span>
          <del
            style={{
              ...props.regularPriceStyle,
              // the shorthand doesn't work in Safari :/
              textDecorationColor: "var(--red)",
              textDecorationLine: "line-through",
              textDecorationStyle: "solid",
              color: props.oldPriceColor,
              marginRight: 5
            }}
          >
            {formatMoneyDisplay(getTaxedPrice(price.price), price.currencyCode)}
          </del>
          <ins style={props.salePriceStyle}>
            {formatMoneyDisplay(getTaxedPrice(price.fromPrice ?? price.salesPrice), price.currencyCode)}
          </ins>
        </>
      ) : (
        <>
          <span style={props.regularPriceStyle}>
            {isNullOrUndefined(price.fromPrice) ? null : i18n.from.toLowerCase() + " "}
          </span>
          <span style={props.regularPriceStyle}>
            {formatMoneyDisplay(getTaxedPrice(price.fromPrice ?? price.price), price.currencyCode)}
          </span>
        </>
      )}
    </div>
  );
};
export default ProductPrice;
